import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue";
import _imports_0 from '@/assets/image/banner.mp4';
import _imports_1 from '../../assets/image/wx-icon.png';
import _imports_2 from '../../assets/image/dy-icon.png';
import _imports_3 from '../../assets/image/xhs-icon.png';
const _hoisted_1 = { class: "home" };
const _hoisted_2 = { class: "info-container max-width" };
const _hoisted_3 = { class: "content" };
const _hoisted_4 = { class: "title" };
const _hoisted_5 = { class: "image" };
const _hoisted_6 = ["src"];
const _hoisted_7 = { class: "intro" };
const _hoisted_8 = { class: "max-width" };
const _hoisted_9 = { class: "text" };
const _hoisted_10 = { class: "card" };
const _hoisted_11 = { class: "carousel-img" };
const _hoisted_12 = ["src"];
const _hoisted_13 = { class: "features" };
const _hoisted_14 = { class: "max-width" };
const _hoisted_15 = { class: "text" };
const _hoisted_16 = { class: "card" };
const _hoisted_17 = { class: "carousel-img" };
const _hoisted_18 = ["src"];
const _hoisted_19 = { class: "contact" };
const _hoisted_20 = { class: "max-width" };
const _hoisted_21 = { class: "platform" };
const _hoisted_22 = { class: "item" };
const _hoisted_23 = { class: "qr" };
const _hoisted_24 = { class: "qr-code" };
const _hoisted_25 = ["src"];
const _hoisted_26 = { class: "item" };
const _hoisted_27 = { class: "qr" };
const _hoisted_28 = { class: "qr-code" };
const _hoisted_29 = ["src"];
const _hoisted_30 = { class: "item" };
const _hoisted_31 = { class: "qr" };
const _hoisted_32 = { class: "qr-code" };
const _hoisted_33 = ["src"];
import { ref, onMounted, computed } from "vue";
import post from "./components/post.vue";
import { getHomeInfo } from "@/api/home";
import aboutImg from "@/assets/image/about.png";
import homeBg from "@/assets/image/home.png";
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const postRef = ref();
        const clickCount = ref(0);
        const homeData = ref({});
        const homeImageList = computed(() => {
            try {
                return JSON.parse(homeData.value.productImages || "[]");
            }
            catch {
                return [];
            }
        });
        const honorImageList = computed(() => {
            try {
                return JSON.parse(homeData.value.honorImages || "[]");
            }
            catch {
                return [];
            }
        });
        const introImageList = computed(() => {
            try {
                return JSON.parse(homeData.value.introImages || "[]");
            }
            catch {
                return [];
            }
        });
        const refreshData = async () => {
            try {
                const res = await getHomeInfo();
                homeData.value = res.data;
            }
            catch {
                // 暂无数据
            }
        };
        onMounted(() => {
            refreshData();
        });
        const handleEdit = () => {
            const token = localStorage.getItem("token");
            if (!token) {
                return;
            }
            clickCount.value++;
            if (clickCount.value >= 2) {
                postRef.value.show(homeData.value);
                clickCount.value = 0;
            }
        };
        return (_ctx, _cache) => {
            const _component_el_carousel_item = _resolveComponent("el-carousel-item");
            const _component_el_carousel = _resolveComponent("el-carousel");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("section", {
                    class: "top-container",
                    onClick: handleEdit
                }, [
                    _cache[1] || (_cache[1] = _createElementVNode("video", {
                        class: "tpm-prod-hero__video",
                        src: _imports_0,
                        autoplay: "",
                        muted: "",
                        loop: "",
                        playsinline: ""
                    }, null, -1)),
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("h1", _hoisted_4, _toDisplayString(homeData.value.productTitle || "纺织无忧用爱布"), 1),
                            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "btn" }, "去使用 →", -1))
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("img", {
                                src: homeImageList.value[0] || _unref(homeBg),
                                alt: "产品展示"
                            }, null, 8, _hoisted_6)
                        ])
                    ])
                ]),
                _createElementVNode("section", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("p", _hoisted_9, _toDisplayString(homeData.value.honorTitle ||
                            "深耕服装行业20年自主研发管理软件荣获多项著作"), 1),
                        _createElementVNode("div", _hoisted_10, [
                            _createVNode(_component_el_carousel, {
                                trigger: "click",
                                interval: 5000,
                                type: "card",
                                height: "400px"
                            }, {
                                default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(honorImageList.value, (img, idx) => {
                                        return (_openBlock(), _createBlock(_component_el_carousel_item, { key: idx }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_11, [
                                                    _createElementVNode("img", {
                                                        src: img,
                                                        alt: "荣誉图片"
                                                    }, null, 8, _hoisted_12)
                                                ])
                                            ]),
                                            _: 2
                                        }, 1024));
                                    }), 128))
                                ]),
                                _: 1
                            })
                        ])
                    ])
                ]),
                _createElementVNode("section", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("p", _hoisted_15, _toDisplayString(homeData.value.introTitle || "专业管理工具 让您的管理更轻松"), 1),
                        _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_el_carousel, {
                                trigger: "click",
                                interval: 5000,
                                type: "card",
                                height: "400px"
                            }, {
                                default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(introImageList.value, (img, idx) => {
                                        return (_openBlock(), _createBlock(_component_el_carousel_item, { key: idx }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_17, [
                                                    _createElementVNode("img", {
                                                        src: img,
                                                        alt: "产品图片"
                                                    }, null, 8, _hoisted_18)
                                                ])
                                            ]),
                                            _: 2
                                        }, 1024));
                                    }), 128))
                                ]),
                                _: 1
                            })
                        ])
                    ])
                ]),
                _createElementVNode("section", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                        _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text" }, "联系方式", -1)),
                        _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "icon" }, [
                                    _createElementVNode("img", {
                                        src: _imports_1,
                                        alt: "微信",
                                        class: "icon"
                                    })
                                ], -1)),
                                _createElementVNode("div", _hoisted_23, [
                                    _createElementVNode("div", _hoisted_24, [
                                        _createElementVNode("img", {
                                            src: homeData.value.wechatQrCode || _unref(aboutImg),
                                            alt: "微信二维码",
                                            class: "qr-code"
                                        }, null, 8, _hoisted_25)
                                    ]),
                                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "qr-text" }, "了解更多，请使用微信扫一扫上方二维码", -1))
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_26, [
                                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "icon" }, [
                                    _createElementVNode("img", {
                                        src: _imports_2,
                                        alt: "抖音",
                                        class: "icon"
                                    })
                                ], -1)),
                                _createElementVNode("div", _hoisted_27, [
                                    _createElementVNode("div", _hoisted_28, [
                                        _createElementVNode("img", {
                                            src: homeData.value.douyinQrCode || _unref(aboutImg),
                                            alt: "抖音二维码",
                                            class: "qr-code"
                                        }, null, 8, _hoisted_29)
                                    ]),
                                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "qr-text" }, "了解更多，请使用抖音扫一扫上方二维码", -1))
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_30, [
                                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "icon" }, [
                                    _createElementVNode("img", {
                                        src: _imports_3,
                                        alt: "小红书",
                                        class: "icon"
                                    })
                                ], -1)),
                                _createElementVNode("div", _hoisted_31, [
                                    _createElementVNode("div", _hoisted_32, [
                                        _createElementVNode("img", {
                                            src: homeData.value.xiaohongshuQrCode || _unref(aboutImg),
                                            alt: "小红书二维码",
                                            class: "qr-code"
                                        }, null, 8, _hoisted_33)
                                    ]),
                                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "qr-text" }, "了解更多，请使用小红书扫一扫上方二维码", -1))
                                ])
                            ])
                        ])
                    ])
                ]),
                _createVNode(post, {
                    ref_key: "postRef",
                    ref: postRef,
                    onSaved: refreshData
                }, null, 512)
            ]));
        };
    }
});
